import {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import Header from '../../components/Header'
import FooterItem from '../../components/FooterItem';
import { getCurrentUserInfo ,UserInfo, ArticleList } from '../../api/mockData';
import {Avatar, Flex,Button,Divider,Descriptions,Tag,Modal,Form,Input,Table} from 'antd'
import {UserOutlined, MailFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import './style.css'
const Auth = function () {
    const [userInfo, setUserInfo] = useState(getCurrentUserInfo());
    const [open,setOpen] = useState(false);
    const [techStackTags, setTechStackTags] = useState(userInfo?.getTechStack() || []);
    const [techStackInput, setTechStackInput] = useState('');
    const [form] = Form.useForm();
    const [userArticles, setUserArticles] = useState([]);
    
    // 过滤当前用户的文章
    useEffect(() => {
        if (userInfo) {
            const articles = ArticleList.filter(article => article.author === userInfo.getName());
            setUserArticles(articles);
        }
    }, [userInfo]);
    
    // 处理文章删除
    const handleDeleteArticle = (id) => {
        // 从ArticleList中删除文章
        const index = ArticleList.findIndex(article => article.id === id);
        if (index !== -1) {
            ArticleList.splice(index, 1);
            // 更新用户文章列表
            setUserArticles(prev => prev.filter(article => article.id !== id));
        }
    };

    const handleEdit = () => {
      // 打开编辑模态框时初始化技术栈Tags
      setTechStackTags(userInfo?.getTechStack() || []);
      setTechStackInput('');
      setOpen(true);
    }
    const handleSubmit = () => {
      form.validateFields().then(values => {
    //     constructor(name,   //required
    //     password = "",  //required
    //     avatar = "",    
    //     introcution  = "无",
    //     details = "这个人很懒，什么都没写",
    //     email = "无",
    //     techStack = [],
    //     interest = "无",
    //     github = "#",
        
        const newUserInfo = new UserInfo(
            userInfo.getName(),
            values.password,
            userInfo.getAvatar(),
            values.introduction,
            values.details,
            values.email,
            techStackTags,
            values.interest,
            values.github,
        )
        // 更新状态
        setUserInfo(newUserInfo);
        setOpen(false);
        
      }).catch(errorInfo => {
        // 表单验证失败时的处理
        console.error('表单验证失败：', errorInfo);
        alert(errorInfo);
      });
    }
    
    // 处理技术栈输入框回车键
    const handleTechStackKeyDown = (e) => {
      if (e.key === 'Enter' && techStackInput.trim()) {
        e.preventDefault();
        // 避免重复添加相同的Tag
        if (!techStackTags.includes(techStackInput.trim())) {
          setTechStackTags([...techStackTags, techStackInput.trim()]);
        }
        setTechStackInput('');
      }
    }
    
    // 处理删除Tag
    const handleTagClose = (removedTag) => {
      const newTags = techStackTags.filter(tag => tag !== removedTag);
      setTechStackTags(newTags);
    }
    return (
        <div>
            <Header index={3}/>
            <div className="auth-container">
              <Flex vertical> 
                <Flex vertical = {false} gap = "small">
                  <div className = "auth-left-container">
                    {/* avatar */}
                     {userInfo?.getAvatar() ? (
                     <Avatar src={userInfo.getAvatar() } size = {196}/>
                    ) : (
                     <Avatar icon={<UserOutlined />} size = {196} />
                    )}  
                    {/* info */}
                    <h1>{userInfo?.getName() || 'User'}</h1>
                    <Divider style={{ borderColor: '#aaa' }}></Divider>
                    <p>{userInfo?.getIntrocution() || 'No Introcution'}</p>
                    <p>{userInfo?.getDetails() || 'No Detail'}</p>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <MailFilled />
                      <span>{userInfo?.getEmail() || 'No Email'}</span>
                    </span>
                    
                    <Button type = "primary" 
                    className = "auth-edit-button" 
                    onClick = {handleEdit}
                    icon = {<EditOutlined />}>
                      修改个人信息
                    </Button>
                  </div>
                  <div className = "auth-right-container">
                    <Descriptions title="其他信息" bordered column={1} className = "auth-descriptions">
                      <Descriptions.Item label="兴趣爱好" className = "auth-descriptions-item">{userInfo?.getInterest() || 'User'}</Descriptions.Item>
                      <Descriptions.Item label="技术栈" className = "auth-descriptions-item">
                        <Flex gap = "small">
                          {userInfo?.getTechStack().map(tech => <Tag color = "blue">{tech}</Tag>) || 'No TechStack'}
                        </Flex>
                      </Descriptions.Item>
                    </Descriptions>
                    
                    <Table
                      columns={[
                        {
                          title: '文章',
                          dataIndex: 'title',
                          key: 'title',
                          width: '60%'
                        },
                        {
                          title: '创建时间',
                          dataIndex: 'createTime',
                          key: 'createTime',
                          width: '30%'
                        },
                        {
                          title: '操作',
                          key: 'action',
                          width: '10%',
                          render: (_, record) => (
                            <Button
                              type="text"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={() => handleDeleteArticle(record.id)}
                            >
                              删除
                            </Button>
                          )
                        }
                      ]}
                      dataSource={userArticles.map(article => ({
                        ...article,
                        key: article.id
                      }))}
                      pagination={false}
                      scroll={{ y: '100%' }}
                      size="middle"
                    />

                  </div>
                </Flex>
              </Flex>
              <Modal
              title = "编辑个人信息"
              closeable = {true}
              width = {600}
              open = {open}
              onOk = {handleSubmit}
              onCancel = {() => setOpen(false)}
              >
                {/* 修改的个人信息有：名字，密码，介绍，详情，邮箱，技术栈，爱好，github */}
                <Form layout="vertical" 
                form = {form}
                className = "auth-form"
                onFinish = {handleSubmit}
                initialValues = {{
                  password: userInfo?.getPassword() || '',
                  introduction: userInfo?.getIntrocution() || '',
                  details: userInfo?.getDetails() || '',
                  email: userInfo?.getEmail() || '',
                  interest: userInfo?.getInterest() || '',
                }}
                >

                  <Form.Item label = "密码" name = "password">
                    <Input.Password />
                  </Form.Item>
                  <Form.Item label = "介绍" name = "introduction">
                    <Input />
                  </Form.Item>
                  <Form.Item label = "详情" name = "details">
                    <Input />
                  </Form.Item>
                  <Form.Item label = "邮箱" name = "email">
                    <Input />
                  </Form.Item>
                  <Form.Item label = "技术栈">
                    <div className="tech-stack-container">
                      {/* 显示已生成的Tags */}
                      <div className="tech-stack-tags">
                        {techStackTags.map(tag => (
                          <Tag 
                            key={tag} 
                            closable 
                            onClose={() => handleTagClose(tag)}
                            style={{ marginBottom: 8 }}
                          >
                            {tag}
                          </Tag>
                        ))}
                      </div>
                      {/* 输入框 */}
                      <Input 
                        value={techStackInput}
                        onChange={(e) => setTechStackInput(e.target.value)}
                        onKeyDown={handleTechStackKeyDown}
                        placeholder="输入技术栈，按回车添加"
                      />
                    </div>
                  </Form.Item>
                  <Form.Item label = "爱好" name = "interest">
                    <Input />
                  </Form.Item>

                </Form>
              </Modal>
            </div>
            <FooterItem/>
        </div>
      
    )
}
export default Auth;